module.exports = __webpack_public_path__ + "static/jess_han-7d2821ec1742906948c8b638c2ec04ff.jpg";